import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/service/process.png';
const _withScopeId = n => (_pushScopeId("data-v-4ca93324"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "process"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "container"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "ws_title"
}, "开发服务流程"), /*#__PURE__*/_createElementVNode("img", {
  class: "process-img",
  src: _imports_0,
  alt: ""
})], -1));
const _hoisted_3 = [_hoisted_2];
export function render(_ctx, _cache) {
  return _openBlock(), _createElementBlock("section", _hoisted_1, _hoisted_3);
}